const GenderImage = Object.freeze({
    MALE: "files/userMale.png",
    FEMALE: "files/userFemale.png"
});

export default GenderImage;